export default __webpack_public_path__ + "static/soehne-web-dreiviertelfett-0c02929dd7efe17c41269ec726a4d4ba.woff2";